import React from 'react'; // import classNames from 'classnames';
// import dateFormat from 'dateformat';

import './section.scss';

function Section(props) {
  var {
    children,
    label
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "sectionContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sectionLabel"
  }, label), /*#__PURE__*/React.createElement("div", null, children));
}

export default Section;